import alertPageTypes from "./alertPage.types";

const INITIAL_STATE = {
  message: "",

  firstBtn: "",
  secondBtn: "",

  firstBtnFunc: "",
  secondBtnFunc: "",

  isVisible: false,
};

const alertPageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case alertPageTypes.TOGGLE_VISIBILITY:
      return {
        ...state,
        isVisible: !state.isVisible,
      };

    case alertPageTypes.SET_MESSAGE:
      return {
        ...state,
        message: action.payload,
      };

    //
    case alertPageTypes.SET_FIRST_BTN:
      return {
        ...state,
        firstBtn: action.payload,
      };
    case alertPageTypes.SET_SECOND_BTN:
      return {
        ...state,
        secondBtn: action.payload,
      };
    //

    //
    case alertPageTypes.SET_FIRST_BTN_FUNC:
      return {
        ...state,
        firstBtnFunc: action.payload,
      };
    case alertPageTypes.SET_SECOND_BTN_FUNC:
      return {
        ...state,
        secondBtnFunc: action.payload,
      };
    //

    //
    case alertPageTypes.SET_ALERTPAGE_CLEAN:
      return INITIAL_STATE;
    //

    default:
      return state;
  }
};

export default alertPageReducer;
